import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/esm/Button';
import '../product/Edit.css';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Edit({ product, setproduct, setShowproduct }) {
  const [EditData, setEditData] = useState({
    title: '',
    price: '',
    category: '',
    image: '',
    description: '',
  });

  useEffect(() => {
    if (product) {
      setEditData({
        title: product.title || '',
        price: product.price || '',
        category: product.category || '',
        image: product.image || '',
        description: product.description || '',
      });
    }
  }, [product]);

  const handleEditProd = async () => {
  
    try {
      const result = await axios.put(`https://fakestoreapi.com/products/${product.id}`, EditData);
      setproduct(prev =>
        prev.map(p => (p.id === product.id ? result.data : p))
      );
      setShowproduct(false);
      toast.success("Product updated successfully! ✅");
    } catch (error) {
      console.error("Error updating product:", error);
      toast.error("Failed to update product ❌");
    }
  };

  const handleChange = (e) => {
    setEditData({ ...EditData, [e.target.name]: e.target.value });
  };

  return (
    
    <div className='Edit-wrap'>
      <Form>
        <h1>Edit Product</h1>
        <div className='edit'>
        <Form.Group className="mb-3" controlId="formGroupTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control type="text" name="title" value={EditData.title} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupPrice">
          <Form.Label>Price</Form.Label>
          <Form.Control type="text" name="price" value={EditData.price} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupCategory">
          <Form.Label>Category</Form.Label>
          <Form.Control type="text" name="category" value={EditData.category} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupImage">
          <Form.Label>Image URL</Form.Label>
          <Form.Control type="text" name="image" value={EditData.image} onChange={handleChange} />
        </Form.Group>
        <Form.Group className="mb-4" controlId="formGroupDescription">
          <Form.Label>Description</Form.Label>
          <Form.Control type="text" name="description" value={EditData.description} onChange={handleChange} />
        </Form.Group>
        <Button variant="primary" onClick={handleEditProd}>Update Product</Button>
        </div>
      </Form>
    </div>
  );
}

export default Edit;
